import { useState, useEffect } from 'react';

export default function HeroBanner() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Exporting Premium Quality Products from India',
      subtitle: 'Delivering premium agricultural and textile products to global markets.',
      cta: 'Contact Us',
      ctaAction: 'contact',
      image: 'https://public.readdy.ai/ai/img_res/a958d44972ae0e75dcc039092dbd83a6.jpg',
    },
    {
      title: 'Trusted Global Supply Partner',
      subtitle: 'High-quality jaggery, spices, mushrooms, and textiles sourced directly from India.',
      cta: 'Get Quote',
      ctaAction: 'contact',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Indian%20export%20products%20including%20jaggery%20blocks%2C%20black%20pepper%2C%20turmeric%20powder%2C%20dried%20mushrooms%20arranged%20beautifully%20on%20rustic%20wooden%20surface%2C%20warm%20lighting%2C%20clean%20minimal%20background%2C%20professional%20product%20photography%2C%20warm%20earth%20tones%2C%20high%20quality%20commercial%20image&width=1920&height=1080&seq=hero2&orientation=landscape',
    },
    {
      title: 'Reliable Export Solutions for Global Buyers',
      subtitle: 'Consistent quality, competitive pricing, and dependable delivery.',
      cta: 'WhatsApp Now',
      ctaAction: 'whatsapp',
      image: 'https://readdy.ai/api/search-image?query=International%20shipping%20containers%20at%20modern%20port%20facility%2C%20cargo%20ships%2C%20global%20trade%20and%20export%20business%2C%20professional%20logistics%2C%20blue%20sky%20background%2C%20clean%20organized%20warehouse%20with%20Indian%20products%20ready%20for%20export%2C%20commercial%20photography%2C%20high%20quality&width=1920&height=1080&seq=hero3&orientation=landscape',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleCTA = (action: string) => {
    if (action === 'whatsapp') {
      window.open('https://wa.me/919743475615', '_blank');
    } else {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden mt-20 lg:mt-24">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>

          {/* Content */}
          <div className="relative h-full flex items-center">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
              <div className="max-w-3xl">
                <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-8 font-light">
                  {slide.subtitle}
                </p>
                <div className="flex flex-wrap gap-4">
                  <button
                    onClick={() => handleCTA(slide.ctaAction)}
                    className="px-8 py-4 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-all hover:shadow-xl flex items-center space-x-2 whitespace-nowrap"
                  >
                    <span>{slide.cta}</span>
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  <button
                    onClick={() => {
                      const element = document.getElementById('about');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-medium hover:bg-white hover:text-gray-900 transition-all flex items-center space-x-2 whitespace-nowrap"
                  >
                    <span>Learn More</span>
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-1 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'w-10 bg-teal-600' : 'w-10 bg-white/30'
            }`}
          ></button>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-6 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
      >
        <i className="ri-arrow-left-line text-white text-xl"></i>
      </button>
      <button
        onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
        className="absolute right-6 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
      >
        <i className="ri-arrow-right-line text-white text-xl"></i>
      </button>
    </section>
  );
}